export function isCoupon(voucher) {
  return voucher.type === 'COUPON'
}
